"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$supplNote = exports.supplNoteToLines = exports.supplNoteControl = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const std_1 = require("../../../law/std");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const inline_1 = require("../../../node/cst/inline");
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
const el_1 = require("../../../node/el");
exports.supplNoteControl = ":suppl-note:";
/**
 * The renderer for {@link std.SupplNote}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplNote.spec.ts) for examples.
 */
const supplNoteToLines = (supplNote, indentTexts) => {
    const lines = [];
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls: [
            new inline_1.Control(exports.supplNoteControl, null, "", null),
        ],
        sentencesArray: [
            new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, supplNote.children)]),
        ],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    return lines;
};
exports.supplNoteToLines = supplNoteToLines;
/**
 * The parser rule for {@link std.SupplNote}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplNote.spec.ts) for examples.
 */
exports.$supplNote = factory_1.factory
    .withName("supplNote")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.controls.some(c => c.control === exports.supplNoteControl)) {
        return item;
    }
    else {
        return null;
    }
}), "line")
    .action(({ line }) => {
    // for (let i = 0; i < children.value.length; i++) {
    //     children.value[i].attr.Num = `${i + 1}`;
    // }
    const children = (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(line.line.sentencesArray);
    const pos = line.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const supplNote = (0, std_1.newStdEL)("SupplNote", {}, children, range);
    return {
        value: supplNote,
        errors: [],
    };
}));
exports.default = exports.$supplNote;
//# sourceMappingURL=$supplNote.js.map